/**
 * Returns true when the given pathname is a route that renders `HomeView`
 * — i.e. the route the `EmployeeAppSkeleton` (header + tabs + spark cards)
 * actually previews.
 *
 * `HomeView` is mounted on:
 *   - `/user`                       → redirects to `/user/sparks`
 *   - `/user/sparks`                → HomeView with `?tab` controlling
 *                                     the Sparks / Earn / Events tab
 *   - `/user/sparks/upcoming`       → HomeView (upcoming status)
 *   - `/user/sparks/complete`       → HomeView (complete status)
 *
 * Everything else under `/user/*` (spark detail, wallet, profile, help,
 * notifications, w9, learn-and-earn, etc.) is a different layout and the
 * home skeleton would be misleading. Those routes get a plain
 * `PageLoading` fallback instead. See `EmployeeLoadingFallback`.
 *
 * Kept as a tiny pure helper so the inline pre-JS skeleton in
 * `public/employee-app-skeleton.js` can mirror exactly the same logic
 * (translated to vanilla JS) without sharing code through the bundle.
 */
export function isEmployeeHomeRoute(pathname: string): boolean {
    if (!pathname) return false;
    // Strip a trailing slash so /user/sparks/ matches /user/sparks.
    const normalized =
        pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
    return (
        normalized === '/user' ||
        normalized === '/user/sparks' ||
        normalized === '/user/sparks/upcoming' ||
        normalized === '/user/sparks/complete'
    );
}
